import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query imageTeleconsultationquery {
        file(relativePath: { eq: "video-consultation.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Vidéo consultation de chirurgie de la main, de l'épaule et du coude avec le Dr Philippe Roure avec le service Doctolib"
        css={css`
          width: 100%;
          @media (max-width: 678px) {
            display: none;
          }
        `}
      />
    )}
  />
)
